module.exports = __webpack_public_path__ + "img/vacuum-dry-ovens.fcf606b9.jpg";